// tslint:disable no-shadowed-variable
import {
  Customer,
  DiscountDocumentType,
  EcomAccessory,
  EcomCoupon,
  EcomPlanAddon,
  EcomProductPlan,
  EcomProductType,
  Lead,
  PackagePriceCalculationSettingsData,
  PackageCalculationMethod,
} from "../../api/models";
import {
  ConfigurationBuildStep,
  FinanceInfo,
  ConfigurationStep,
  ConfigurationVehicle,
  LeadConfiguration,
  LeadConfigurationType,
  TradeInInfo,
  ConfigurationEcomPlan,
  ConfigurationAccessory,
  ConfigurationAccessoryPackage,
  ConfigurationCampaignCashBack,
  Discount,
} from "../../api/models/configuration";
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from "../utils";
import { OorjitCart } from "../../oorjit-api/models";
import { OorjitProductDetailsData } from "../../oorjit-api/models/product";

import { EcomAddon } from "../../api/models/ecom/addon";
import {
  CampaignDiscountDocument,
  EcomCampaign,
  EcomCampaignAppliedItem,
} from "../../api/models/ecom/campaign";
import { LeadRequirement } from "../../api/models/requirement";

const ACTION_REQUEST_CONFIGURATION = "CONFIGURATION/REQUEST_CONFIGURATION";
const ACTION_LOADED_CONFIGURATION = "CONFIGURATION/LOADED_CONFIGURATION";
const ACTION_LOAD_ERROR_CONFIGURATION =
  "CONFIGURATION/LOAD_ERROR_CONFIGURATION";
const ACTION_OPEN_CONFIGURATION_MODAL =
  "CONFIGURATION/OPEN_CONFIGURATION_MODAL";
const ACTION_ECOM_ACCESS_TOKEN_ERROR = "CONFIGURATION/ECOM_ACCESS_TOKEN_ERROR";
const ACTION_ECOM_ACCESS_TOKEN_LOADED =
  "CONFIGURATION/ECOM_ACCESS_TOKEN_LOADED";
const ACTION_REQUEST_ECOM_ACCESS_TOKEN =
  "CONFIGURATION/REQUEST_ECOM_ACCESS_TOKEN";
const ACTION_RESET_CONFIGURATION = "CONFIGURATION/RESET_CONFIGURATION";
const ACTION_SET_SELECTED_ACTION = "CONFIGURATION/SET_SELECTED_ACTION";
const ACTION_SET_CURRENT_STEP = "CONFIGURATION/SET_CURRENT_STEP";
const ACTION_SET_CURRENT_BUILD_STEP = "CONFIGURATION/SET_CURRENT_BUILD_STEP";
const ACTION_SET_OORJIT_CART_DATA = "CONFIGURATION/SET_OORJIT_CART_DATA";
const ACTION_SET_OORJIT_PRODUCT_DATA = "CONFIGURATION/SET_OORJIT_PRODUCT_DATA";
const ACTION_SET_VEHICLE_DATA = "CONFIGURATION/SET_VEHICLE_DATA";
const ACTION_SET_TPL_DATA = "CONFIGURATION/SET_TPL_DATA";
const ACTION_SET_REGISTATION_DATA = "CONFIGURATION/SET_REGISTATION_DATA";
const ACTION_SET_LEAD = "CONFIGURATION/SET_LEAD";
const ACTION_SET_ACCESSORIES = "CONFIGURATION/SET_ACCESSORIES";
const ACTION_SET_ACCESSORY_PACKAGES = "CONFIGURATION/SET_ACCESSORY_PACKAGES";
const ACTION_SET_CAMPAIGNS = "CONFIGURATION/SET_CAMPAIGNS";
const ACTION_SET_CAMPAIGN_CASHBACKS = "CONFIGURATION/SET_CAMPAIGN_CASHBACKS";
const ACTION_SET_ADDONS = "CONFIGURATION/SET_ADDONS";
const ACTION_SET_SERVICE_PACKAGE = "CONFIGURATION/SET_SERVICE_PACKAGE";
const ACTION_SET_CUSTOMER_CARE_PACKAGE =
  "CONFIGURATION/SET_CUSTOMER_CARE_PACKAGE";
const ACTION_SET_EXTENDED_WARRANTY_PACKAGE =
  "CONFIGURATION/SET_EXTENDED_WARRANTY_PACKAGE";
const ACTION_SET_INSURANCE = "CONFIGURATION/SET_INSURANCE";
const ACTION_SET_TRADE_IN = "CONFIGURATION/SET_TRADE_IN";
const ACTION_SET_FINANCE = "CONFIGURATION/SET_FINANCE";
const ACTION_SET_COUPONS = "CONFIGURATION/SET_COUPONS";
const ACTION_SET_FINANCE_CAMPAIGN_DOCUMETNS =
  "CONFIGURATION/SET_FINANCE_CAMPAIGN_DOCUMETNS";
const ACTION_SET_CAMPAIGN_APPLIED_ITEM_DOCUMETNS =
  "CONFIGURATION/SET_CAMPAIGN_APPLIED_ITEM_DOCUMETNS";
const ACTION_UPDATE_DISCOUNT = "CONFIGURATION/UPDATE_DISCOUNT";
const ACTION_UPDATE_EXCESS_AMOUNT_ADJUSTMENT =
  "CONFIGURATION/UPDATE_EXCESS_AMOUNT_ADJUSTMENT";
const ACTION_SET_LOCKED_DATE = "CONFIGURATION/SET_LOCKED_DATE";
const ACTION_OPEN_PREBOOKING_MODAL = "CONFIGURATION/OPEN_PREBOOKING_MODAL";

export interface ConfigurationLeadData {  
  leadId?: string;
  lead?: Lead;
  requirementId?: string;
}

export type ConfigurationActions =
  | "quotation"
  | "orderNow"
  | "confirmOrder"
  | "cancel"
  | "paymentSummary"
  | "orderEdit"
  | "pushLine"
  | "bookNow"
  | "cancelInvoice"
  | "createInvoice"
  | "syncInvoice";

export interface EcomProductData {
  updatingEcom?: boolean;
  loading?: boolean;
  error?: boolean;
  product?: OorjitProductDetailsData;
  productId?: string;
  combinationSku?: string;
  resetCampaigns?: boolean;
  addTpl?: string;
  addReg?: string;
  isPreVin?: 1 | 0;
  canChangeCampaigns?: boolean;
  isComplete?: boolean;
}

export interface ConfigurationState {
  leadId?: string;
  configId?: string;
  requirementId?: string;
  customer?: Customer;
  lead?: Lead;
  configuration?: LeadRequirement;
  loaded?: boolean;
  loading?: boolean;
  error?: any;
  modalOpen?: boolean;
  preBookingModalOpen?: boolean;
  buildMode?: boolean;
  fromLead?: boolean;
  ecomAccessToken?: {
    loading?: boolean;
    loaded?: boolean;
    token?: string;
    error?: any;
  };
  ecomProductData?: EcomProductData;
  cart?: OorjitCart;
  hasStock?: boolean;
  hasCombination?: boolean;
  currentStep?: ConfigurationStep;
  currentBuildStep?: ConfigurationBuildStep;
  isEdited?: boolean;
  selectedAction?: ConfigurationActions;
  availableCampaigns?: EcomCampaign[];
  documentTypes?: DiscountDocumentType[];
  packagePriceCalculationSettings?: PackagePriceCalculationSettingsData;
}

const initialState: ConfigurationState = {
  loaded: false,
  loading: false,
  modalOpen: false,
};

type RequestConfigurationActionType = IActionWithPayload<
  typeof ACTION_REQUEST_CONFIGURATION,
  ConfigurationLeadData
>;

type ConfigurationLoadedActionType = IActionWithPayload<
  typeof ACTION_LOADED_CONFIGURATION,
  ConfigurationLeadData & {
    configuration?: LeadRequirement;
    currentStep: ConfigurationStep;
    documentTypes: DiscountDocumentType[];
    packagePriceCalculationSettings?: PackagePriceCalculationSettingsData;
  }
>;
type ConfigurationLoadErrorActionType = IActionWithPayload<
  typeof ACTION_LOAD_ERROR_CONFIGURATION,
  ConfigurationLeadData & {
    error: any;
  }
>;

type EcomAccessTokenErrorActionType = IActionWithPayload<
  typeof ACTION_ECOM_ACCESS_TOKEN_ERROR,
  {
    error: any;
  }
>;

type EcomAccessTokenLoadedActionType = IActionWithPayload<
  typeof ACTION_ECOM_ACCESS_TOKEN_LOADED,
  {
    token: string;
  }
>;

type RequestEcomAccessTokenActionType = IAction<
  typeof ACTION_REQUEST_ECOM_ACCESS_TOKEN
>;
type ResetConfigurationActionType = IAction<typeof ACTION_RESET_CONFIGURATION>;

type OpenConfigurationModalActionType = IActionWithPayload<
  typeof ACTION_OPEN_CONFIGURATION_MODAL,
  { open?: boolean; buildMode?: boolean; fromLead?: boolean }
>;

type OpenPreBookingModalActionType = IActionWithPayload<
  typeof ACTION_OPEN_PREBOOKING_MODAL,
  { open?: boolean; buildMode?: boolean; fromLead?: boolean }
>;

type SetConfigurationSelectedActionActionType = IActionWithPayload<
  typeof ACTION_SET_SELECTED_ACTION,
  ConfigurationActions | undefined
>;

type SetConfigurationInvoiceLockedDateActionType = IActionWithPayload<
  typeof ACTION_SET_LOCKED_DATE,
  { isAdd: boolean }
>;

type SetCurrentStepActionType = IActionWithPayload<
  typeof ACTION_SET_CURRENT_STEP,
  ConfigurationStep | undefined
>;

type SetCurrentBuildStepActionType = IActionWithPayload<
  typeof ACTION_SET_CURRENT_BUILD_STEP,
  ConfigurationBuildStep | undefined
>;

type SetOorjitCartDataActionType = IActionWithPayload<
  typeof ACTION_SET_OORJIT_CART_DATA,
  {
    ecomConfigID?: number;
    cart?: OorjitCart;
    hasStock?: boolean;
  }
>;

type SetConfigurationVehicleActionType = IActionWithPayload<
  typeof ACTION_SET_VEHICLE_DATA,
  {
    vehicle?: ConfigurationVehicle;
    hasCombination?: boolean;
    tpl?: ConfigurationEcomPlan;
    registration?: ConfigurationEcomPlan;
    canChange?: boolean;
  }
>;

type SetConfigurationTplActionType = IActionWithPayload<
  typeof ACTION_SET_TPL_DATA,
  {
    tpl?: ConfigurationEcomPlan;
  }
>;

type SetConfigurationRegistrationActionType = IActionWithPayload<
  typeof ACTION_SET_REGISTATION_DATA,
  {
    registration?: ConfigurationEcomPlan;
  }
>;

type SetOorjitProductDataActionType = IActionWithPayload<
  typeof ACTION_SET_OORJIT_PRODUCT_DATA,
  {
    productData: EcomProductData;
    tpl?: ConfigurationEcomPlan;
    registration?: ConfigurationEcomPlan;
  }
>;

type SetAccessoriesActionType = IActionWithPayload<
  typeof ACTION_SET_ACCESSORIES,
  EcomAccessory[]
>;

type SetAccessoryPackagesActionType = IActionWithPayload<
  typeof ACTION_SET_ACCESSORY_PACKAGES,
  ConfigurationAccessoryPackage[]
>;

type SetCampaignsActionType = IActionWithPayload<
  typeof ACTION_SET_CAMPAIGNS,
  EcomCampaign[]
>;

type SetCampaignCashbacksActionType = IActionWithPayload<
  typeof ACTION_SET_CAMPAIGN_CASHBACKS,
  ConfigurationCampaignCashBack[]
>;

type SetAddOnsActionType = IActionWithPayload<
  typeof ACTION_SET_ADDONS,
  EcomAddon[]
>;

type SetConfigurationLeadActionType = IActionWithPayload<
  typeof ACTION_SET_LEAD,
  Lead
>;

type SetServicePackageActionType = IActionWithPayload<
  typeof ACTION_SET_SERVICE_PACKAGE,
  ConfigurationEcomPlan | undefined
>;

type SetCustomerCarePackageActionType = IActionWithPayload<
  typeof ACTION_SET_CUSTOMER_CARE_PACKAGE,
  ConfigurationEcomPlan | undefined
>;

type SetExtendedWarrantyPackageActionType = IActionWithPayload<
  typeof ACTION_SET_EXTENDED_WARRANTY_PACKAGE,
  ConfigurationEcomPlan | undefined
>;

type SetInsuranceActionType = IActionWithPayload<
  typeof ACTION_SET_INSURANCE,
  ConfigurationEcomPlan | undefined
>;

type SetTradeInsActionType = IActionWithPayload<
  typeof ACTION_SET_TRADE_IN,
  TradeInInfo[]
>;

type SetFinanceActionType = IActionWithPayload<
  typeof ACTION_SET_FINANCE,
  FinanceInfo | undefined
>;

type SetCouponsActionType = IActionWithPayload<
  typeof ACTION_SET_COUPONS,
  EcomCoupon[] | undefined
>;

type SetDiscountUpdateActionType = IActionWithPayload<
  typeof ACTION_UPDATE_DISCOUNT,
  {
    discounts?: Discount[];
    otherDiscounts?: Discount[];
    insurance?: ConfigurationEcomPlan;
  }
>;

type SetExcessAmountAdjustmentActionType = IActionWithPayload<
  typeof ACTION_UPDATE_EXCESS_AMOUNT_ADJUSTMENT,
  LeadConfiguration | undefined
>;

type SetFinanceCampaignDocumentsActionType = IActionWithPayload<
  typeof ACTION_SET_FINANCE_CAMPAIGN_DOCUMETNS,
  CampaignDiscountDocument[] | undefined
>;

type SetCampaignAppliedItemDocumentsActionType = IActionWithPayload<
  typeof ACTION_SET_CAMPAIGN_APPLIED_ITEM_DOCUMETNS,
  | {
    documents?: CampaignDiscountDocument[];
    appliedItem: EcomCampaignAppliedItem;
    campaignID: string;
  }
  | undefined
>;

type Actions =
  | RequestConfigurationActionType
  | ConfigurationLoadedActionType
  | ConfigurationLoadErrorActionType
  | OpenConfigurationModalActionType
  | OpenPreBookingModalActionType
  | EcomAccessTokenErrorActionType
  | EcomAccessTokenLoadedActionType
  | RequestEcomAccessTokenActionType
  | ResetConfigurationActionType
  | SetConfigurationSelectedActionActionType
  | SetConfigurationInvoiceLockedDateActionType
  | SetCurrentStepActionType
  | SetOorjitCartDataActionType
  | SetOorjitProductDataActionType
  | SetConfigurationVehicleActionType
  | SetConfigurationRegistrationActionType
  | SetConfigurationTplActionType
  | SetConfigurationLeadActionType
  | SetAccessoriesActionType
  | SetAccessoryPackagesActionType
  | SetCampaignsActionType
  | SetCampaignCashbacksActionType
  | SetAddOnsActionType
  | SetInsuranceActionType
  | SetServicePackageActionType
  | SetCustomerCarePackageActionType
  | SetExtendedWarrantyPackageActionType
  | SetTradeInsActionType
  | SetFinanceActionType
  | SetCurrentBuildStepActionType
  | SetCouponsActionType
  | SetFinanceCampaignDocumentsActionType
  | SetCampaignAppliedItemDocumentsActionType
  | SetDiscountUpdateActionType
  | SetExcessAmountAdjustmentActionType;

export const resetConfigurationData = (): ResetConfigurationActionType => {
  return createAction(ACTION_RESET_CONFIGURATION);
};
export const requestConfigurationAction = (
  data: ConfigurationLeadData
): RequestConfigurationActionType => {
  return createActionWithPayload(ACTION_REQUEST_CONFIGURATION, data);
};

export const configurationLoadedAction = (
  data: ConfigurationLeadData & {
    configuration?: LeadRequirement;
    currentStep: ConfigurationStep;
    documentTypes: DiscountDocumentType[];
    packagePriceCalculationSettings?: PackagePriceCalculationSettingsData;
  }
): ConfigurationLoadedActionType => {
  return createActionWithPayload(ACTION_LOADED_CONFIGURATION, data);
};

export const configurationLoadErrorAction = (
  data: ConfigurationLeadData & {
    error: any;
  }
): ConfigurationLoadErrorActionType => {
  return createActionWithPayload(ACTION_LOAD_ERROR_CONFIGURATION, data);
};

export const openConfigurationModalAction = (data: {
  open?: boolean;
  buildMode?: boolean;
  fromLead?: boolean;
}): OpenConfigurationModalActionType => {
  return createActionWithPayload(ACTION_OPEN_CONFIGURATION_MODAL, data);
};

export const openPreBookingModalAction = (data: {
  open?: boolean;
  buildMode?: boolean;
  fromLead?: boolean;
}): OpenPreBookingModalActionType => {
  return createActionWithPayload(ACTION_OPEN_PREBOOKING_MODAL, data);
};

export const ecomAccessTokenErrorAction = (data: {
  error: any;
}): EcomAccessTokenErrorActionType => {
  return createActionWithPayload(ACTION_ECOM_ACCESS_TOKEN_ERROR, data);
};

export const ecomAccessTokenLoadedAction = (data: {
  token: string;
}): EcomAccessTokenLoadedActionType => {
  return createActionWithPayload(ACTION_ECOM_ACCESS_TOKEN_LOADED, data);
};

export const requestEcomAccessTokenAction = (): RequestEcomAccessTokenActionType => {
  return createAction(ACTION_REQUEST_ECOM_ACCESS_TOKEN);
};

export const setConfigurationSelectedAction = (
  action?: ConfigurationActions
): SetConfigurationSelectedActionActionType => {
  return createActionWithPayload(ACTION_SET_SELECTED_ACTION, action);
};

export const setConfigurationInvoiceLockedDate = (
  isAdd: boolean
): SetConfigurationInvoiceLockedDateActionType => {
  return createActionWithPayload(ACTION_SET_LOCKED_DATE, { isAdd });
};

export const setConfigurationVehiceAction = (data: {
  vehicle?: ConfigurationVehicle;
  hasCombination?: boolean;
  tpl?: ConfigurationEcomPlan;
  registration?: ConfigurationEcomPlan;
  canChange?: boolean;
}): SetConfigurationVehicleActionType => {
  return createActionWithPayload(ACTION_SET_VEHICLE_DATA, data);
};

export const setConfigurationTplAction = (data: {
  tpl?: ConfigurationEcomPlan;
}): SetConfigurationTplActionType => {
  return createActionWithPayload(ACTION_SET_TPL_DATA, data);
};

export const setConfigurationRegistrationAction = (data: {
  registration?: ConfigurationEcomPlan;
}): SetConfigurationRegistrationActionType => {
  return createActionWithPayload(ACTION_SET_REGISTATION_DATA, data);
};

export const setConfigurationAccessoriesAction = (
  accessories: EcomAccessory[]
): SetAccessoriesActionType => {
  return createActionWithPayload(ACTION_SET_ACCESSORIES, accessories);
};

export const setConfigurationAccessoryPackagesAction = (
  accessoryPackages: ConfigurationAccessoryPackage[]
): SetAccessoryPackagesActionType => {
  return createActionWithPayload(
    ACTION_SET_ACCESSORY_PACKAGES,
    accessoryPackages
  );
};

export const setConfigurationCampaignsAction = (
  campaigns: EcomCampaign[]
): SetCampaignsActionType => {
  return createActionWithPayload(ACTION_SET_CAMPAIGNS, campaigns);
};

export const setConfigurationCampaignCashBacksAction = (
  cashbacks: ConfigurationCampaignCashBack[]
): SetCampaignCashbacksActionType => {
  return createActionWithPayload(ACTION_SET_CAMPAIGN_CASHBACKS, cashbacks);
};

export const setConfigurationAddonsAction = (
  addons: EcomAddon[]
): SetAddOnsActionType => {
  return createActionWithPayload(ACTION_SET_ADDONS, addons);
};

export const setConfigurationInsuranceAction = (
  insurance?: ConfigurationEcomPlan
): SetInsuranceActionType => {
  return createActionWithPayload(ACTION_SET_INSURANCE, insurance);
};

export const setConfigurationServicePackageAction = (
  servicePackage?: ConfigurationEcomPlan
): SetServicePackageActionType => {
  return createActionWithPayload(ACTION_SET_SERVICE_PACKAGE, servicePackage);
};

export const setConfigurationCustomerCarePackageAction = (
  customerCarePackage?: ConfigurationEcomPlan
): SetCustomerCarePackageActionType => {
  return createActionWithPayload(
    ACTION_SET_CUSTOMER_CARE_PACKAGE,
    customerCarePackage
  );
};

export const setConfigurationExtendedWarrantyAction = (
  extendedWarranty?: ConfigurationEcomPlan
): SetExtendedWarrantyPackageActionType => {
  return createActionWithPayload(
    ACTION_SET_EXTENDED_WARRANTY_PACKAGE,
    extendedWarranty
  );
};

export const setConfigurationCurrentStepAction = (
  step?: ConfigurationStep
): SetCurrentStepActionType => {
  return createActionWithPayload(ACTION_SET_CURRENT_STEP, step);
};

export const setConfigurationCurrentBuildStepAction = (
  step?: ConfigurationBuildStep
): SetCurrentBuildStepActionType => {
  return createActionWithPayload(ACTION_SET_CURRENT_BUILD_STEP, step);
};

export const setOorjitCartDataAction = (data: {
  ecomConfigID?: number;
  cart?: OorjitCart;
  hasStock?: boolean;
}): SetOorjitCartDataActionType => {
  return createActionWithPayload(ACTION_SET_OORJIT_CART_DATA, data);
};

export const setOorjitProductDataAction = (data: {
  productData: EcomProductData;
  tpl?: ConfigurationEcomPlan;
  registration?: ConfigurationEcomPlan;
}): SetOorjitProductDataActionType => {
  return createActionWithPayload(ACTION_SET_OORJIT_PRODUCT_DATA, data);
};

export const setConfigurationLeadAction = (
  lead: Lead
): SetConfigurationLeadActionType => {
  return createActionWithPayload(ACTION_SET_LEAD, lead);
};

export const setConfigurationTradeInsAction = (
  tradeIns: TradeInInfo[]
): SetTradeInsActionType => {
  return createActionWithPayload(ACTION_SET_TRADE_IN, tradeIns);
};

export const setConfigurationFinanceAction = (
  finance?: FinanceInfo
): SetFinanceActionType => {
  return createActionWithPayload(ACTION_SET_FINANCE, finance);
};

export const setCouponsAction = (
  coupons?: EcomCoupon[]
): SetCouponsActionType => {
  return createActionWithPayload(ACTION_SET_COUPONS, coupons);
};

export const setDiscountUpdateAction = (
  discounts?: Discount[],
  otherDiscounts?: Discount[],
  insurance?: ConfigurationEcomPlan
): SetDiscountUpdateActionType => {
  return createActionWithPayload(ACTION_UPDATE_DISCOUNT, {
    discounts,
    otherDiscounts,
    insurance,
  });
};

export const setExcessAmountAdjustmentUpdateAction = (
  configuration?: LeadConfiguration
): SetExcessAmountAdjustmentActionType => {
  return createActionWithPayload(
    ACTION_UPDATE_EXCESS_AMOUNT_ADJUSTMENT,
    configuration
  );
};

export const setFinanceCampaignDocumentsAction = (
  documents?: CampaignDiscountDocument[]
): SetFinanceCampaignDocumentsActionType => {
  return createActionWithPayload(
    ACTION_SET_FINANCE_CAMPAIGN_DOCUMETNS,
    documents
  );
};

export const setCampaignAppliedItemDocumentsAction = (data: {
  campaignID: string;
  appliedItem: EcomCampaignAppliedItem;
  documents?: CampaignDiscountDocument[];
}): SetCampaignAppliedItemDocumentsActionType => {
  return createActionWithPayload(
    ACTION_SET_CAMPAIGN_APPLIED_ITEM_DOCUMETNS,
    data
  );
};

// helpers
const getAllAddonsOfEcomConfigurationPlan = (
  plans: EcomProductPlan[] | undefined,
  productID: string,
  productOptionID: string
): EcomPlanAddon[] | undefined => {
  if (!plans?.length) {
    return;
  }
  const plan = plans?.find((p) => p.productID === productID);
  if (!plan) {
    return;
  }
  const option = plan.optionsList?.find(
    (op) => op.productOptionID === productOptionID
  );
  return option?.addons;
};

const addMatchingAddonToCorrespondingEntities = (
  ecomProductData: EcomProductData | undefined,
  configuration?: LeadConfiguration
) => {
  if (!ecomProductData || !configuration) {
    return;
  }

  const allSelectedPackages = getAllSelectedPackages(configuration);

  if (configuration.customerCare) {
    const allAddons = getAllAddonsOfEcomConfigurationPlan(
      ecomProductData.product?.customerCarePackages,
      configuration.customerCare.productID,
      configuration.customerCare.productOptionID
    );
    const addOns = addMatchingAddons(
      configuration.customerCare.addOns || [],
      allAddons || [],
      allSelectedPackages
    );
    configuration.customerCare = {
      ...configuration.customerCare,
      addOns,
    };
  }
  if (configuration.extendedWarranty) {
    const allAddons = getAllAddonsOfEcomConfigurationPlan(
      ecomProductData.product?.extendedWarrenty,
      configuration.extendedWarranty.productID,
      configuration.extendedWarranty.productOptionID
    );
    const addOns = addMatchingAddons(
      configuration.extendedWarranty.addOns || [],
      allAddons || [],
      allSelectedPackages
    );
    configuration.extendedWarranty = {
      ...configuration.extendedWarranty,
      addOns,
    };
  }
  if (configuration.insurance) {
    const allAddons = getAllAddonsOfEcomConfigurationPlan(
      ecomProductData.product?.insurancesList,
      configuration.insurance.productID,
      configuration.insurance.productOptionID
    );
    const addOns = addMatchingAddons(
      configuration.insurance.addOns || [],
      allAddons || [],
      allSelectedPackages
    );

    configuration.insurance = {
      ...configuration.insurance,
      addOns,
    };
  }
  if (configuration.registration) {
    const allAddons = getAllAddonsOfEcomConfigurationPlan(
      ecomProductData.product?.registrationPrice,
      configuration.registration.productID,
      configuration.registration.productOptionID
    );
    const addOns = addMatchingAddons(
      configuration.registration.addOns || [],
      allAddons || [],
      allSelectedPackages
    );
    configuration.registration = {
      ...configuration.registration,
      addOns,
    };
  }
  if (configuration.servicePackage) {
    const allAddons = getAllAddonsOfEcomConfigurationPlan(
      ecomProductData.product?.servicesList,
      configuration.servicePackage.productID,
      configuration.servicePackage.productOptionID
    );
    const addOns = addMatchingAddons(
      configuration.servicePackage.addOns || [],
      allAddons || [],
      allSelectedPackages
    );
    configuration.servicePackage = {
      ...configuration.servicePackage,
      addOns,
    };
  }
  if (configuration.tpl) {
    const allAddons = getAllAddonsOfEcomConfigurationPlan(
      ecomProductData.product?.tplPrice,
      configuration.tpl.productID,
      configuration.tpl.productOptionID
    );
    const addOns = addMatchingAddons(
      configuration.tpl.addOns || [],
      allAddons || [],
      allSelectedPackages
    );
    configuration.tpl = {
      ...configuration.tpl,
      addOns,
    };
  }
};

const getAllSelectedPackages = (
  configuration?: LeadConfiguration
): {
  productType: EcomProductType;
  productID: string;
  productOptionID: string;
}[] => {
  if (!configuration) {
    return [];
  }
  const allSelectedPackages: {
    productType: EcomProductType;
    productID: string;
    productOptionID: string;
  }[] = [];
  if (configuration.customerCare) {
    allSelectedPackages.push({
      productType: EcomProductType.CustomerCarePackage,
      productID: configuration.customerCare.productID,
      productOptionID: configuration.customerCare.productOptionID,
    });
  }
  if (configuration.extendedWarranty) {
    allSelectedPackages.push({
      productType: EcomProductType.ExtendedWarranty,
      productID: configuration.extendedWarranty.productID,
      productOptionID: configuration.extendedWarranty.productOptionID,
    });
  }
  if (configuration.insurance) {
    allSelectedPackages.push({
      productType: EcomProductType.Insurance,
      productID: configuration.insurance.productID,
      productOptionID: configuration.insurance.productOptionID,
    });
  }
  if (configuration.registration) {
    allSelectedPackages.push({
      productType: EcomProductType.Registration,
      productID: configuration.registration.productID,
      productOptionID: configuration.registration.productOptionID,
    });
  }
  if (configuration.servicePackage) {
    allSelectedPackages.push({
      productType: EcomProductType.ServicePackage,
      productID: configuration.servicePackage.productID,
      productOptionID: configuration.servicePackage.productOptionID,
    });
  }
  if (configuration.tpl) {
    allSelectedPackages.push({
      productType: EcomProductType.TPL,
      productID: configuration.tpl.productID,
      productOptionID: configuration.tpl.productOptionID,
    });
  }

  return allSelectedPackages;
};

const addMatchingAddons = (
  existingAddOns: EcomPlanAddon[],
  allAddOns: EcomPlanAddon[],
  selectedPackages: {
    productType: EcomProductType;
    productID: string;
    productOptionID: string;
  }[]
): EcomPlanAddon[] => {
  const addOns = existingAddOns.filter(
    (ad) => ad.productType === EcomProductType.InsuranceAddons
  );
  const newAddons = allAddOns.filter((add) =>
    selectedPackages.find(
      (sp) =>
        add.productType === sp.productType &&
        add.packageID === sp.productID &&
        add.packageOptionID === sp.productOptionID
    )
  );
  if (newAddons.length) {
    addOns.push(...newAddons);
  }
  return addOns;
};

// reducer
export const configurationReducer = (
  state: ConfigurationState = initialState,
  action: Actions
): ConfigurationState => {
  switch (action.type) {
    case ACTION_REQUEST_CONFIGURATION:
      return {
        ...state,
        leadId: action.payload.leadId,
        lead: action.payload.lead,
        requirementId: action.payload.requirementId,
        // customer: action.payload.customer,
        loading: true,
        loaded: false,
        isEdited: false,
      };
    case ACTION_LOADED_CONFIGURATION:
      return {
        ...state,
        loaded: true,
        loading: false,
        configuration: {
          ...action.payload.configuration!,
        },
        currentStep: action.payload.currentStep,
        leadId: action.payload.leadId,
        lead: action.payload.lead,
        requirementId: action.payload.requirementId,
        // customer: action.payload.customer,
        isEdited: false,
        documentTypes: action.payload.documentTypes,
        packagePriceCalculationSettings:
          action.payload.packagePriceCalculationSettings,
      };
    case ACTION_LOAD_ERROR_CONFIGURATION:
      return {
        ...state,
        loaded: true,
        loading: false,
        leadId: action.payload.leadId,
        requirementId: action.payload.requirementId,
        // customer: action.payload.customer,
        lead: action.payload.lead,
        error: action.payload.error,
        isEdited: false,
      };
    case ACTION_OPEN_CONFIGURATION_MODAL:
      return {
        ...state,
        modalOpen: action.payload.open,
        buildMode: action.payload.buildMode,
        fromLead: action.payload.fromLead,
      };
    case ACTION_OPEN_PREBOOKING_MODAL:
      return {
        ...state,
        preBookingModalOpen: action.payload.open,
        buildMode: action.payload.buildMode,
        fromLead: action.payload.fromLead,
      };
    case ACTION_REQUEST_ECOM_ACCESS_TOKEN:
      return {
        ...state,
        ecomAccessToken: {
          token: undefined,
          error: undefined,
          loaded: false,
          loading: true,
        },
      };
    case ACTION_ECOM_ACCESS_TOKEN_LOADED:
      return {
        ...state,
        ecomAccessToken: {
          token: action.payload.token,
          error: undefined,
          loaded: true,
          loading: false,
        },
      };
    case ACTION_ECOM_ACCESS_TOKEN_ERROR:
      return {
        ...state,
        ecomAccessToken: {
          token: undefined,
          error: action.payload.error,
          loaded: true,
          loading: false,
        },
      };
    case ACTION_RESET_CONFIGURATION:
      return {
        ...initialState,
      };
    case ACTION_SET_SELECTED_ACTION:
      return {
        ...state,
        selectedAction: action.payload,
      };
    case ACTION_SET_LOCKED_DATE:
      return {
        ...state,
        configuration: {
          ...state.configuration!,
        },
      };
    case ACTION_SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    case ACTION_SET_CURRENT_BUILD_STEP:
      return {
        ...state,
        currentBuildStep: action.payload,
      };
    case ACTION_SET_OORJIT_CART_DATA:
      return {
        ...state,
        configuration: {
          ...state.configuration!,
        },
        hasStock: action.payload.hasStock,
        cart: action.payload.cart,
      };
    case ACTION_SET_LEAD:
      return {
        ...state,
        leadId: action.payload._id,
        isEdited: action.payload._id !== state.leadId,
        configuration: {
          ...state.configuration!,
          leadDetails: action.payload,
          configurationType:
            state.configuration?.configurationType ||
            LeadConfigurationType.Configuration,
          salesPerson: action.payload.currentSalesPerson,
        },
        lead: action.payload,
      };

    default:
      return state;
  }
};
